interface ContactEmail {
  email: string;
  primary: boolean;
}

interface ContactPhone {
  phone: string;
  primary: boolean;
  type: string;
}

export interface Contact {
  customerId: number;
  district: string;
  districtId: number | null;
  division: string | null;
  divisionId: number | null;
  firstName: string;
  fullName: string;
  id: number;
  lastName: string;
  title: string;
  contactEmails: ContactEmail[];
  contactPhones: ContactPhone[];
}

interface ApiResponse<T> {
  data: T;
  isSuccessful: boolean;
  message: string;
}

import apiClient from './index';

// Get contact by customer ID and contact ID
export const getContact = async (customerId: number, contactId: number): Promise<Contact> => {
  try {
    const response = await apiClient.get<ApiResponse<Contact>>(`/Contact/Read/${customerId}/${contactId}`);
    if (!response.isSuccessful) {
      throw new Error(response.message || 'Failed to fetch contact');
    }
    return response.data;
  } catch (error: any) {
    console.error(`Error fetching contact (Customer ID: ${customerId}, Contact ID: ${contactId}):`, error.message);
    throw error;
  }
};

// Update an existing contact
export const updateContact = async (contactData: Contact): Promise<Contact> => {
  try {
    console.log('[DAWA API] Contact update request', {
      endpoint: '/Contact/Update',
      payloadPreview: {
        id: contactData.id,
        customerId: contactData.customerId,
        firstName: contactData.firstName,
        lastName: contactData.lastName,
        district: contactData.district,
        districtId: contactData.districtId,
        emailsCount: contactData.contactEmails?.length || 0,
        phonesCount: contactData.contactPhones?.length || 0,
      }
    });
    const response = await apiClient.post<Contact, ApiResponse<Contact>>('/Contact/Update', contactData);
    console.log('[DAWA API] Contact update response', {
      isSuccessful: (response as any)?.isSuccessful,
      hasData: !!(response as any)?.data,
    });
    if (!response.isSuccessful) {
      throw new Error(response.message || 'Failed to update contact');
    }
    return response.data;
  } catch (error: any) {
    console.error(`Error updating contact with ID ${contactData.id}:`, error.message);
    throw error;
  }
};

// Example usage of how to use these functions:
/*
// Fetching a contact for the current user's customer
import { getCurrentCustomerId } from '@/utils/token';

const customerId = getCurrentCustomerId();
if (customerId) {
  const contact = await getContact(parseInt(customerId), 524); // contactId would come from user data
  console.log(contact.fullName); // "Aaron Daily3"
}

// Updating a contact
const updatedContactData: Contact = {
  ...existingContact,
  firstName: "Updated First Name",
  lastName: "Updated Last Name",
  contactEmails: [
    {
      email: "new.email@example.com",
      primary: true
    }
  ]
};
const updatedContact = await updateContact(updatedContactData);
*/
